import { useAuth } from '@ts-core/modules/auth/hooks';

import { UserFragment } from '../graphql/fragments';
import { User } from '../types/User';

export default function useProfessorAuth() {
  return useAuth<User>({ UserFragment });
}
